import { HistogramItemResponseModel } from "./histogram-item-response.model";

export class HistogramResponseModel {
    public totalCount = 0;
    public items: Array<HistogramItemResponseModel> = [];
}